export default "__VITE_ASSET__ca09d768__"